<template>
    <div id="hashtag">
        <Header />
        <div class="menu">
            <div class="container">
                <ul>
                    <li :class="{'on' : currHsIdx === 0}">
                        <router-link tag="a" to="/Hashtag/0">#전체</router-link>
                    </li>
                    <li v-for="(item, index) in hashList" :key="index" :class="{'on' : currHsIdx === item.hsIdx}">
                        <router-link tag="a" :to="'/Hashtag/' + item.hsIdx">
                            {{item.hsName}}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="container">
            
            <b-row tag="div" cols="5">
                <b-col tag="div" v-for="(item, index) in hashWebtoonList" :key="index" @click="moveDetail(item)">
                    <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="item.adult === 1">
                    <div class="top">
                        <img :src="siteConfig.cdnUrl + '/KR/title/' + item.englishName + '.jpg'">
                    </div>
                    <div class="middle">
                        <p class="name">{{item.titleName}}</p>
                        <!-- <p class="up_check">UP</p> -->
                    </div>
                    <div class="bottom">
                        <p>{{item.publisher}}</p>
                        <p class="view">{{item.viewTotal}} 회</p>
                    </div>
                </b-col>
            </b-row>
            <div class="paging" v-if="totalRecordSize > 0">
                <a @click="prevPage()"><img src="../assets/images/arrow_left.svg" /></a>
                <a class="current" v-if="pageList.length <= 0">1</a>
                <a v-for="(item, index) in pageList" :key="index" :class="{'current' : item === currentPageNo}" @click="movePage(item)">{{item}}</a>
                <a @click="nextPage()"><img src="../assets/images/arrow_right.svg" /></a>
            </div>
        </div>
        <Footer />
        <Login :initIsShowPopup="isShowLoginPopup" @close="close('Login')" />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Login from '@/components/Login.vue'

export default {
    name: 'Tag',
    pageCategory: '',
    components: {
        Header,
        Footer,
        Login,
    },
    data() {
        return {
            currHsIdx: 0,
            currScending: 0,
            currSort: 0,

            hashList: [],
            hashWebtoonList: [],

            currentPageNo: 1,      //현재 페이지 번호
            currentPageSize: 10,    //한번에 불러올 게시물 수
            maxPageCount:10,        //한 화면에 보여질 페이지 수

            listCount: 0,
            pageCount: 0,
            pageNo: 0,
            pageSize: 0,
            totalRecordSize: 0,

            pageList:[],

            isShowLoginPopup: false,

        }
    },
    async created(){
        await this.mixinSiteConfigCheck();

        if(this.$route.params.idx){
            this.currHsIdx = Number(this.$route.params.idx);
        }

        this.getHash();
        this.getHashWebtoonList();

    },
    methods: {
        prevPage(){
            if(this.currentPageNo > 1){
                this.currentPageNo--;
                this.getHashWebtoonList();
            }
        },
        nextPage(){
            if(this.currentPageNo < this.pageCount){
                this.currentPageNo++;
                this.getHashWebtoonList();
            }
        },
        movePage(no){
            if(this.currentPageNo === no)
                return;

            this.currentPageNo = no;
            this.getHashWebtoonList();
        },
        changePage(){
            this.pageList = [];
            if(this.pageCount === 0)
                return;

            var tmpPageNo = this.currentPageNo - 2;
            if(this.currentPageNo + 2 > this.pageCount){
                tmpPageNo--;
            }
            if(this.currentPageNo +1 > this.pageCount){
                tmpPageNo--;
            }
            for(var i=0; i<5 && tmpPageNo <= this.pageCount; ){
                if(tmpPageNo >= 1){
                    this.pageList.push(tmpPageNo);
                    i++;
                }
                tmpPageNo++;   
            }
        },
        getHash(){ // 해시 태그 정보

            this.mixin_hashtagList.forEach(item =>{
                if(item.adult === this.$store.state.isCheckedAdult){
                    this.hashList.push(item);
                }
            })

            this.selectedKeywordTagIdx = this.hashList[0].hsIdx;

            // var param = 
            // {
            //     // limit : 3
            // }
            // this.$Axios.post(`${this.host}/infotag`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
            //     // console.log('----태그----');
            //     // console.log(res.data);
            //     if (res.data.returnCode === 0) {
            //         this.hashList = res.data.list;
            //     }
            // })
            // .catch((error) => {
            //     console.log(error);
            // });
        },
        getHashName(hash_idx){
            var name = '';
            this.hashList.forEach(element =>{
                if(hash_idx === element.hsIdx){
                    name = element.hsName;
                }
            })
            return name;
        },
        getHashWebtoonList(){
            var param = 
            {
                hashtag: this.currHsIdx,
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/hashtag`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.hashWebtoonList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    this.changePage();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        moveDetail(item){
            
            if(item.adult === 1){
                if(this.$store.state.loginCheck === false){
                    this.isShowLoginPopup = true;
                }
                else if(!this.$store.state.adult){
                    var src = this.siteConfig.niceUrl + '?email=' + this.$store.state.email;
                    window.open(src, 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=no');
                }
                else{
                    // this.$router.push('/Toondetail/' + item.englishName);
                    this.$router.push('/Toondetail/' + item.webToonIndex);
                }
            }else{
                // this.$router.push('/Toondetail/' + item.englishName);
                this.$router.push('/Toondetail/' + item.webToonIndex);
            }
            
        },
    }
}
</script>